import {TabContent} from '../TabContent'

export const Entity = ({data}) => {
  return <TabContent tab={'Entity'} data={data} />
}
